<template>
  <div class="container my-4">
    <router-link :to="{ name: 'ConfigurationsView', query: { deviceName: encodeURI(this.deviceName) } }">
      <fa-icon :icon="['fas', 'chevron-left']" class="mr-2" />{{ deviceName }} Konfigurationen
    </router-link>
    <div class="d-flex align-items-center justify-content-between mt-3 mb-4">
      <h4 class="mb-0">{{ deviceName }} Filter bearbeiten</h4>
      <div>
        <b-button variant="outline-primary" v-on:click="speichern">
          <fa-icon :icon="['fas', 'plus']" class="mr-2" />Filterkategorie erstellen
        </b-button>
      </div>
    </div>
    <div v-if="isLoading === false">
      <b-table striped hover :items="filter" :fields="fields" empty-text="Keine Daten vorhanden" show-empty>
        <template #cell(name)="row">
          <router-link
            :to="{
              name: 'EditConfigurationFilterView',
              params: {
                filterId: row.item.id,
              },
              query: {
                deviceName: $route.query.deviceName,
                filterName: row.item.data.name,
              },
            }"
          >
            {{ row.item.data.name }}
          </router-link>
        </template>

        <template #cell(actions)="row">
          <div class="d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              title="Löschen"
              v-on:click="loeschen(row.item.id, row.item.data.name)"
            >
              <fa-icon icon="trash" />
            </button>
          </div>
        </template>
      </b-table>
    </div>
    <SpinnerComponent v-else />
  </div>
</template>

<script>
import SpinnerComponent from "../components/SpinnerComponent";

import {firestore} from "../plugins/firebase"
import { addDoc, collection, getDocs, query, deleteDoc, doc } from "firebase/firestore"

export default {
  name: "ConfigurationFiltersView",
  components: {
    SpinnerComponent,
  },
  computed: {
    deviceName: function() {
      return decodeURI(this.$route.query.deviceName);
    },
    deviceId: function() {
      return decodeURI(this.$route.params.deviceId);
    },
  },
  mounted() {
    this.laden();
  },
  data() {
    return {
      isLoading: true,
      filter: [],
      fields: [
        {
          key: "name",
          label: "Bezeichnung",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  methods: {
    speichern() {
      addDoc(collection(firestore, "filter"), {
        name: "Filterkategorie",
        type: "",
        deviceId: this.deviceId,
        filter: [],
      })
      .then(() => this.laden())
      .catch((error) => console.error(error)); // eslint-disable-line no-console
    },
    async laden() {
      this.filter = [];

      const q = query(collection(firestore, 'filter') )

     await getDocs(q)
    .then(docs=>{
      this.isLoading = false
      docs.forEach((document) => {
        if (document.data().deviceId === this.deviceId) {
          const element = {
            id: document.id,
            data: document.data(),
          };
          this.filter.push(element);
        }
      });
    })
    .catch(err=>{console.error(err)})

    },
    loeschen: function(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Soll der Filter "${name}" wirklich gelöscht werden?`, {
          title: "",
          okVariant: "danger",
          okTitle: "OK",
          cancelTitle: "Abbrechen",
          hideHeaderClose: false,
          noCloseOnBackdrop: true,
        })
        .then((value) => {
          if (value === true) {

            deleteDoc(doc(firestore, "filter", id))
            .then(() => {
              for (let i = 0; i < this.filter.length; i++) {
                if (this.filter[i].id === id) {
                  this.filter.splice(i, 1);
                  i--;
                }
              }
            })
            .catch((error) => console.error(error)); // eslint-disable-line no-console
          }
        })
        .catch((error) => console.error(error)); // eslint-disable-line no-console
    },
  },
};
</script>
